import formSuporte from '../../components/formSuporte/formSuporte.vue';

export default {
    name: "solicitacaoSuporte",
    components: {
        formSuporte,
    },
}